import { Expose } from 'class-transformer'
import { DocumentSnapshot } from 'firebase/firestore'
import { _FirebaseDocument } from './Models'

export type TaskGroupingSubjectPriority = 'critical' | 'high' | 'medium'

export class TaskGroupingSubject extends _FirebaseDocument {
    @Expose()
    public title!: string

    @Expose()
    public description!: string

    @Expose()
    public priority!: TaskGroupingSubjectPriority

    @Expose()
    public summary!: string

    @Expose()
    public order!: number

    @Expose()
    public taskRefs!: string[]

    collection(): string {
        return 'task_grouping'
    }

    static fromFirebase(o: DocumentSnapshot): TaskGroupingSubject | null {
        return _FirebaseDocument._fromFirebase(TaskGroupingSubject, o)
    }
}
